// apps/widget/src/screens/error.screen.tsx
//
// Errors are specific, and every one that can be recovered from offers the
// recovery. A generic "something went wrong" with a reload button is the
// version of this screen that loses the scan.

import { t } from '../lib/i18n';

const MESSAGES: Record<string, string> = {
  QUOTA_EXCEEDED: 'error.quota',
  TENANT_NOT_LIVE: 'error.notLive',
  QUALITY_GATE_FAILED: 'error.quality',
  ORIGIN_NOT_ALLOWED: 'error.notLive',
  SESSION_EXPIRED: 'qr.expired',
};

/** Codes where retrying the same thing would fail the same way. */
const TERMINAL = new Set(['QUOTA_EXCEEDED', 'TENANT_NOT_LIVE', 'ORIGIN_NOT_ALLOWED']);

interface Props {
  code: string;
  message: string;
  fixes?: string[];
  onRetry?: () => void;
}

export function ErrorScreen({ code, message, fixes, onRetry }: Props) {
  const localised = MESSAGES[code];
  const canRetry = Boolean(onRetry) && !TERMINAL.has(code);

  return (
    <div className="gs-stack gs-centred">
      <div className="gs-icon-circle gs-icon-circle--muted" aria-hidden="true">
        !
      </div>

      <h1 className="gs-title">{localised ? t(localised) : t('error.title')}</h1>

      {/* The server's message when it has one — it is written for this
          situation and ours is not. */}
      <p className="gs-body">{message}</p>

      {fixes && fixes.length > 0 && (
        <ul className="gs-facts">
          {fixes.map((fix) => (
            <li key={fix}>{fix}</li>
          ))}
        </ul>
      )}

      {canRetry && (
        <button className="gs-btn gs-btn--primary" onClick={onRetry}>
          {t('error.retry')}
        </button>
      )}
    </div>
  );
}
